import { Component, Injector } from '@angular/core';
import type { OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { IonicModule } from '@ionic/angular';

import { Constants } from '@shared/models';
import { DocumentsService } from '@shared/services';
import { ViewBasePage } from '@shared/pages';

@Component({
    'selector': 'app-introduction',
    'templateUrl': './introduction.page.html',
    'styleUrls': ['./introduction.page.scss'],
    'standalone': true,
    'imports': [ CommonModule, FormsModule, IonicModule ]

})
export class IntroductionPage extends ViewBasePage implements OnInit {
    public myHTML = {};

    constructor(private documentsService: DocumentsService, injector: Injector) {
        super(injector);
    }

    public ionViewWillEnter(): void {
        super.setCurrentView(this.Constants.VIEW_INTRODUCTION);
    }

    public override ngOnInit(): void {
        super.ngOnInit();
        this.loadDocument();
        // this.initMoreMenu();
    }

    // public initMoreMenu(): void {
    //     this.resetPopoverMenu();
    //     this.pushPopoverMenuItem('Show Tour', 'show-introduction-tour');
    // }

    public async loadDocument() {
        try {
            await this.uxHelperService.showSpinner('Loading data.');
            const metaData = this.documentsService.getDocumentMetaDataByViewName(Constants.VIEW_INTRODUCTION);
            const doc = await this.documentsService.getByUid(metaData.uid);

            // const content: any = await this.firebazeStorageService.getMiscDocument(Constants.DOCUMENT_INTRODUCTION);
            this.myHTML = doc.contents;
        } catch (err) {
            await this.uxHelperService.hideSpinner();
            const errorMessage = this.utilsService.extractError(err, 'Introduction document not found.');
            // const msg = errorMessage || 'Introduction document not found.';
            this.uxHelperService.showAlert('Error', errorMessage);
        } finally {
            await this.uxHelperService.hideSpinner();
        }
    }
}
